import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=d4e34a32&scoped=true"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=d4e34a32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e34a32",
  null
  
)

export default component.exports